import { ViewFactory } from 'wdc-cube-react'
import { SectionHeaderScope } from '..'
import { SectionHeaderView } from './SectionHeader.view'

export function registerViews(rv = ViewFactory.register) {
    rv(SectionHeaderScope, SectionHeaderView)
}
